<template>
  <v-data-table
    :headers="headers"
    :items="cards"
    item-key="_id"
    sort-by="tipo"
    class="elevation-1"
    dense
    hide-default-footer
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    show-expand    
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog v-model="dialog" max-width="1000px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" dense>
              Nuova card
            </v-btn>
            <v-spacer></v-spacer>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4" >
                    <v-text-field v-model="editedItem.tipo" label="Tipo"></v-text-field> <!-- accesso .. -->
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem._id" label="Codice"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <v-text-field v-model="editedItem.dataAssociazione" label="Data Ass." ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <!-- <v-text-field v-model="editedItem.dallaData" label="Dalla data" ></v-text-field> -->
                    <v-menu v-model="menuData[0]" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="formatDate(editedItem.dallaData)" label="Dalla data" prepend-inner-icon="mdi-calendar" readonly dense v-bind="attrs" v-on="on" clearable hide-details @click:clear="editedItem.dallaData = null"></v-text-field>
                      </template>
                      <v-date-picker v-model="editedItem.dallaData" no-title scrollable @input="menuData[0] = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <!-- <v-text-field v-model="editedItem.allaData" label="Alla data" ></v-text-field> -->
                    <v-menu v-model="menuData[1]" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field :value="formatDate(editedItem.allaData)" label="Alla data" prepend-inner-icon="mdi-calendar" readonly dense v-bind="attrs" v-on="on" clearable hide-details @click:clear="editedItem.allaData = null"></v-text-field>
                      </template>
                      <v-date-picker v-model="editedItem.allaData" no-title scrollable @input="menuData[1] = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" > 
                    <!-- <v-text-field v-model="editedItem.status" label="Stato"></v-text-field> -->
                    <v-switch v-model="editedItem.abilita" label="Attiva" class="mt-1" inset @change="onChangeStatus"></v-switch>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.accesso.numeroIngressi"
                      type="number"
                      label="Numero ingressi contati / massimi"
                      :prefix="`${editedItem.accesso.numeroIngressiContati} / `"
                      hint="E' possibile inserire un numero massimo di ingressi permessi"
                      persistent-hint
                    >
                    <template v-slot:append-outer>
                      <v-icon title="Reset contatore" @click="resetIngressiContati">mdi-counter</v-icon>
                    </template>
                  </v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                Annulla
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
              >
                Salva
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Sei sicuro di voler cancellare questa card?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Annulla</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.ingressi`]="{ item }">
      {{ item.accesso.numeroIngressi ? `${item.accesso.numeroIngressiContati} / ${item.accesso.numeroIngressi}` : '' }}
    </template>
    <template v-slot:[`item.dallaData`]="{ item }">
      {{ item.dallaData | dateNull }}
    </template>
    <template v-slot:[`item.allaData`]="{ item }">
      {{ item.allaData | dateNull }}
    </template>    
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      Nessuna card definita
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" class="clientiSelected">
        <accessi-card :idCliente="idCliente" :idCard="item._id"/>
      </td>
    </template>        
  </v-data-table>
</template>

<script>
  import moment from 'moment'
  import fidelity from '@/services/fidelityService'
  import AccessiCard from './dettagli/accessiCard.vue'
  /* eslint-disable */
  export default {
    components: {
      AccessiCard
    },
    props: {
      idCliente: String,
      cliente: Object,
      refresh: Number
    },
    data: () => ({
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Tipo',
          align: 'start',
          sortable: false,
          value: 'tipo',
        },
        { text: 'Codice', value: '_id' },
        { text: 'Data Ass.', value: 'dataAssociazione' },
        { text: 'Dalla data', value: 'dallaData' },
        { text: 'Alla data', value: 'allaData' },
        { text: 'Stato', value: 'status' },
        { text: 'Ingressi', value: 'ingressi' },
        { text: 'Actions', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' }
      ],
      cards: [],
      editedIndex: -1,
      editedItem: {
        tipo: 'accesso',
        _id: '',
        dataAssociazione: '',
        dallaData: null,
        allaData: null,
        regole: [],
        infoAggiuntive: {},
        status:  '',
        abilita: false,
        accesso: {
          numeroIngressiContati: 0,
          numeroIngressi: 0,
          istanteReset: null
        }
      },
      defaultItem: {
        tipo: 'accesso',
        _id: '',
        dataAssociazione: '',
        dallaData: null,
        allaData: null,
        regole: [],
        infoAggiuntive: {},
        status:  '',
        abilita: false,
        accesso: {
          numeroIngressiContati: 0,
          numeroIngressi: 0,
          istanteReset: null
        }
      },
      singleExpand: false,
      expanded: [],
      menuData: {}
    }),
    async mounted() {
      await this.refreshAccessi()
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuova card' : 'Modifica card'
      }     
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      async refresh(val) {
        await this.refreshAccessi()
      }
    },
    methods: {
      async refreshAccessi() {
        const elenco = await fidelity.cercaFidelityByCliente('accesso', this.idCliente)
        this.cards = []
        if (elenco.length === 0) {
          return
        }
        let newCards = []
        for (let cc of elenco) {
          let tipo = 'accesso'
          let card = {
            tipo: tipo,
            _id: cc._id,
            dataAssociazione: moment(cc.dataAssociazione).format('DD/MM/YYYY'),
            dallaData: cc.dallaData ? moment(cc.dallaData).format('YYYY-MM-DD') : '',
            allaData: cc.allaData ? moment(cc.allaData).format('YYYY-MM-DD') : '',
            status: cc.status,
            abilita: cc.abilita,
            accesso: {
              numeroIngressiContati: (cc.accesso && cc.accesso.numeroIngressiContati) || 0,
              numeroIngressi: (cc.accesso && cc.accesso.numeroIngressi) || 0
            }
          }
          newCards.push(card)
        }
        Object.assign(this.cards, newCards)
      },
      resetIngressiContati() {
        if (confirm('Confermi annullamento contatore ingressi effettuati ?')) {
          this.editedItem.accesso.numeroIngressiContati = 0
          this.editedItem.accesso.istanteReset = new Date()
        }
      },
      onChangeStatus() {
        this.editedItem.status = this.editedItem.abilita ? 'attiva' : 'non attiva'
      },
      formatDate (date) {
        if (!date) return null
        date = date.substring(0, 10)
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      editItem (item) {
        this.editedIndex = this.cards.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.cards.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.cards.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async save () {
        if (this.editedIndex === -1 ) {
          let dati = {
            abilita: this.editedItem.abilita,
            dallaData: this.editedItem.dallaData ? moment(this.editedItem.dallaData).utcOffset(0, true).toISOString() : null,
            allaData: this.editedItem.allaData ? moment(this.editedItem.allaData).utcOffset(0, true).toISOString() : null,
            status: this.editedItem.status || '',
            accesso: this.editedItem.accesso || null,
            regole: [],
            infoAggiuntive: {},
            tipo: 'accesso' 
          }
          const cliente = {
            codice: this.cliente.codice,
            ragioneSociale: this.cliente.ragioneSociale
          }
          const card = await fidelity.creaCardAccessiCliente(dati, cliente)   
          await this.refreshAccessi()
        } else {
          const accesso = {
            abilita: this.editedItem.abilita,
            dallaData: moment(this.editedItem.dallaData).utcOffset(0, true).toISOString(),
            allaData: moment(this.editedItem.allaData).utcOffset(0, true).toISOString(),
            status: this.editedItem.status,
            accesso: this.editedItem.accesso
          }
          await fidelity.aggiornaAccesso(this.editedItem._id, accesso)
          Object.assign(this.cards[this.editedIndex], this.editedItem)       
        }
        this.close()
      },
      onChangeTipo(item) {

      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
  td.clientiSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
